import React, { useState, useEffect } from "react";
import FavoriteCheckbox from "../../atoms/FavoriteCheckbox";
import ListingCard from "../../atoms/ListingCard";

const AuctionLostList = (props) => {
  return (
    <>
      {props.data.map((item, index) => {
        return <ListingCard item={item} from="lost" />;
      })}
    </>
  );
};

export default AuctionLostList;
